import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'navigation-kit-avatar.title',
		defaultMessage: 'Select an avatar',
		description: 'The text is shown at the title on the navigation kit avatar popup',
	},
	close: {
		id: 'navigation-kit-avatar.close',
		defaultMessage: 'Close avatar selection',
		description: 'The label for the button to close the avatar selection popup',
	},
	error: {
		id: 'navigation-kit-avatar.error',
		defaultMessage: 'Error updating project avatar.',
		description: 'The error message to show when there is an error updating the project avatar',
	},
	cancelUpload: {
		id: 'navigation-kit-avatar.cancel-upload',
		defaultMessage: 'Cancel',
		description: 'The label for the button to cancel the avatar upload',
	},
	submitUpload: {
		id: 'navigation-kit-avatar.submit-upload',
		defaultMessage: 'Submit',
		description: 'The label for the button to submit the avatar upload',
	},
	uploadImageErrorMessage: {
		id: 'navigation-kit-avatar.upload-image-error-message',
		defaultMessage: "We couldn't upload the image. Check your connection and try again.",
		description:
			'The selected image could not be uploaded due to an unknown issue. The user should check their connection and try to upload the image again',
	},
	updateAvatarErrorMessage: {
		id: 'navigation-kit-avatar.update-avatar-error-message',
		defaultMessage: "We couldn't save the changes. Check your connection and try again.",
		description:
			'The selected avatar could not be updated due to an unknown issue. The user should check their connection and try to update the avatar again',
	},
	imageUrlInvalidError: {
		id: 'navigation-kit-avatar.image-url-invalid-error',
		defaultMessage: 'Could not load image, the url is invalid.',
		description: 'There was an error parsing the image url',
	},
	imageFormatInvalidError: {
		id: 'navigation-kit-avatar.image-format-invalid-error',
		defaultMessage: 'Could not load image, the format is invalid.',
		description: 'The provided image format is not valid',
	},
	imageSizeTooLargeError: {
		id: 'navigation-kit-avatar.image-size-too-large-error',
		defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
		description: 'The provided image size is too big',
	},
	selectImageToUploadOrDragAndDrop: {
		id: 'navigation-kit-avatar.select-image-to-upload-or-drag-and-drop',
		defaultMessage: '<link>Select an image to upload</link> or drag and drop it here',
		description:
			'Label for link used to upload an image. Also indicates that this is a dropbox upload field as an alternative way to upload an image',
	},
});
